module.exports = __webpack_public_path__ + "media/images/result_sets/circles/9n8r3n6r-c8c929490a0c3235c16c4f9b1c1a4847.svg";